import { CircularProgress, SxProps } from "@mui/material";

const Spinner = ({ sx }: { sx?: SxProps }) => (
  <CircularProgress size={16} color="inherit" sx={{ my: 0.5, ...sx }} />
);

export default Spinner;
